import React from "react";

import PropTypes from "prop-types";

import RuleRowText from "../../RulesRenderer/RuleRowText/RuleRowText";


const CertificationAction = ({ rule }) => (
	<div>
		<RuleRowText column="action" rule={rule} />
	</div>
);

CertificationAction.propTypes = {
	rule: PropTypes.object,
};

export default CertificationAction;
